import React from "react";
import { connect } from "react-redux";
import { startLogin } from "../actions/auth";

export const LoginPage = ({ startLogin }) => (
    <div className="box-layout">
        <div className="box-layout__box upgrade_notice">
            <div className="logo-link_div">
                <a href="" className="logo-link"><img className="main-logo" src="/images/FullLogo_Transparent_NoBuffer.png"></img></a>
            </div>
            <div className="notice notice__warning">
                <p>This site is best viewed on iOS 12 devices, Galaxy 20 Plus/Ultra devices, or later. Please use one of the late model devices specified or view our site on a desktop.</p>
            </div>
        </div>
        <div className="box-layout__box">
            <a href="" className="logo-link"><img className="main-logo" src="/images/FullLogo_Transparent_NoBuffer.png"></img></a>
            <br></br>
            <div className="notice_icon">
                <span className="fa-solid fa-circle-info fa-xl fa-fw fa-beat-fade" data-fa-transform="down-6"></span>
            </div>            
            <div className="notice notice__info">
                <p>Welcome to TrackIt! This app is a demonstration of <a href="https://www.authfx.io/" title="Learn more about AuthFX." target="_blank">AuthFX</a>, a universal authentication broker that offers seamless, multi-IDP registration and single sign-on for your web or mobile application. <a href="https://www.authfx.io/" title="Learn more about AuthFX." target="_blank">Learn more</a></p>
            </div>
            <div className="login_modal_icons">
                <span className="spend_icon"><img src="/images/spend.png"></img></span>
                <span className="record_icon"><img src="/images/record.png"></img></span>
                <span className="track_icon"><img src="/images/track.png"></img></span>
                <span className="save_icon"><img src="/images/save.png"></img></span> 
            </div>
            <div className="required_info_notice">
                <p>Ready to take control of your expenses?<br></br>TrackIt requires your:</p>
                <p></p>
                <p className="left-text">Display Name<br></br>Email Address</p>
            </div>
            <div className="security_notice">
                <div className="align-center">
                    <div className="security-badge">
                        <img src="/images/cyber-security-badge.png"></img>
                    </div>
                    <div className="security_text">
                        <p>Your information is secured with <a href="https://www.authfx.io/privacy-policy/" title="Your Privacy & Security" target="_blank">256-bit encryption</a>.</p>
                    </div>

                </div>
            </div>
            <button className="button" onClick={startLogin}>Continue with AuthFX</button>
            <div className="login-explainer">
                <div className="explainer_question"><span className="question">What's this?</span></div>
                <div className="explainer_text">AuthFX allows you to interact with applications using profiles you already have with existing providers. Eliminate account sprawl by registering or logging in to applications using existing profiles rather then creating new ones. This protects your privacy and puts you in control of your identity!  For more information visit <a href="https://www.authfx.io" target="_blank" title="Learn more about AuthFX.">https://www.authfx.io</a>.</div>
            </div>
        </div>   
    </div>
);

const mapDispatchToProps = (dispatch) => ({
    startLogin: () => dispatch(startLogin())
});

export default connect(undefined, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage.js